import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=090c6f46&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=090c6f46&lang=less&scoped=true"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=090c6f46&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c6f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090c6f46')) {
      api.createRecord('090c6f46', component.options)
    } else {
      api.reload('090c6f46', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=090c6f46&scoped=true", function () {
      api.rerender('090c6f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/SideMenu.vue"
export default component.exports